import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

// export const GetB2BTRFRegistrationListData = async (clientCode, orgId,startDate, endDate) => {
//     //debugger;
//     var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/GetB2BTRFRegistrationListData?clientCode=${clientCode}&orgId=${orgId}&startDate=${startDate}&endDate=${endDate}`, CommonVariables.API_HEADER)).then(response => response);
//     return result;
// }

export const GetB2BTRFRegistrationListData = async (payload) => {
    //debugger;
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `B2BRegistration/GetB2BTRFRegistrationListData`, JSON.stringify(payload), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetUniversalB2BTRFRegistrationDataList = async (searchData, clientCode) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/GetB2BTRFRegistrationList?searchData=${searchData}&clientCode=${clientCode}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetB2BTRFRegistrationDetailByTRFId = async (trfId) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/GetB2BTRFRegistrationDetailByTRFId?trfId=${trfId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetHistoryAttributesByTRFId = async (trfId) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/GetHistoryAttributesByTRFId?trfId=${trfId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const RepushFailedRegistration = async (trfId) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/RepushFailedRegistration?trfId=${trfId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UpdateHistoryAttributes = async (payload) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `B2BRegistration/UpdateHistoryAttributes`, JSON.stringify(payload), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UpdateRecollectSample = async (payload) => {
    console.log(payload);
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `B2BRegistration/UpdateRegistrationSampleStatus`, JSON.stringify(payload), CommonVariables.API_HEADER)).then(response => response);
    return result;
}
